var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsImgPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 200,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H310C315.523 0 320 4.47715 320 10V200H0V10Z",
    fill: "#FAC91F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1396_1456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 320,
    height: 200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H310C315.523 0 320 4.47715 320 10V200H0V10Z",
    fill: "#FAC91F"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1396_1456)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1396_1456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -61,
    y: -40,
    width: 341,
    height: 280
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.205 72.662H82.4382V93.4284H103.205V72.662Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.232 72.662H112.466V93.4284H133.232V72.662Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.205 103.323H82.4382V124.089H103.205V103.323Z",
    fill: "#DEDEDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.232 103.323H112.466V124.089H133.232V103.323Z",
    fill: "#DEDEDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.07 153.024L64.3175 214.806L-44.4041 153.024V42.778L63.656 -19.8951L78.7849 -11.4102L95.2082 -22.5125L63.5409 -40L-61 30.1226V165.334L62.6493 235.572L189.405 165.104V75.0781H234.677V58.4822L140.912 3.97761L123.769 15.2812L197.43 60.5819L168.955 58.5973L169.07 153.024Z",
    fill: "#DEDEDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8631 180.607L74.7582 193.263L29.2562 165.219V75.1931H-15.9294V58.9424L154.545 -40L279.747 29.9212V165.449L154.775 239.426L124.316 218.631L142.58 207.989L154.66 216.675L263.267 153.024V42.3178L154.89 -19.665L21.3178 58.3672H49.6487L49.7925 153.024L94.8631 180.607Z",
    fill: "#DEDEDE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1396_1456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H310C315.523 0 320 4.47715 320 10V200H0V10Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsImgPlaceholder);
export default __webpack_public_path__ + "static/media/teams-img-placeholder.6fdf6af6a6ed2a2f22c1db4a715cc109.svg";
export { ForwardRef as ReactComponent };